import { useState } from 'react';
import { axiosApi } from '../../api/setupApi';

const useAddNisFsResult = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const addNisFsResult = async (data) => {
    try {
      setLoading(true);
      const response = await axiosApi.post('/nisfsResult/insert', data);
      if (response && response.data && response.data.success) {
        setSuccess(response.data.message || 'FS Result successfully added!');
        setError(null);
        return { success: true, message: response.data.message };
      }
      setError(response.data?.error || 'Failed to add FS Result.');
      return { success: false, message: response.data?.error };
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'An error occurred while adding FS Result.';
      setError(msg);
      setSuccess(null);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  };

  return { loading, success, error, addNisFsResult };
};

export default useAddNisFsResult;
